/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listMemoriesApp} from '../api'

export const useMutationListMemoriesApp = createReactQueryMutationHook('listMemoriesApp', listMemoriesApp)
